export default {
    index:   { method: 'get',    url: 'menu_access_blocks?with=menus,roles' },
    store:   { method: 'post',   url: 'menu_access_blocks' },
    update:  { method: 'put',    url: 'menu_access_blocks/{id}' },
    destroy: { method: 'delete', url: 'menu_access_blocks/{id}' },
}
